import script from "./LatestVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestVideos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__